import {
    Box,
    Text,
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    Button,
    Input,
    InputGroup,
    InputRightElement,
    Flex,
    TableContainer,
    Avatar,
    Badge,
    HStack,
} from "@chakra-ui/react";
import { FiSearch, FiUserX, FiEye } from "react-icons/fi";
import { useState } from "react";
import Navbar from "../../Navbar/Navbar";
import Sidebar from "../../Sidebar";
import { Link } from "react-router-dom";

/* -------- Dummy Data (Replace with API) -------- */
const bettors = Array.from({ length: 4 }, (_, i) => ({
    id: i + 1,
    name: `Unverified User ${i + 1}`,
    username: `@unverified${i + 1}`,
    email: `user${i + 1}@example.com`,
    mobile: `+12345678${i}`,
    country: i % 2 === 0 ? "AF" : "US",
    joined: "2026-01-03 02:05 PM",
    ago: `${i + 1} hours ago`,
    balance: "₹0.00",
}));

const SIDEBAR_WIDTH = "240px";
const ITEMS_PER_PAGE = 8;

export default function KycUnverified() {
    const [page, setPage] = useState(1);
    const [search, setSearch] = useState("");

    const filtered = bettors.filter(
        (b) =>
            b.name.toLowerCase().includes(search.toLowerCase()) ||
            b.username.toLowerCase().includes(search.toLowerCase())
    );

    const totalPages = Math.ceil(filtered.length / ITEMS_PER_PAGE);
    const data = filtered.slice(
        (page - 1) * ITEMS_PER_PAGE,
        page * ITEMS_PER_PAGE
    );

    return (
        <>
            <Navbar />
            <Sidebar />
            <Box
                p={{ base: 4, md: 8 }}
                bg="#f8f9fd"
                minH="100vh"
                mt="80px"
                ml={{ base: 0, md: SIDEBAR_WIDTH }}
            >
                {/* HEADER */}
                <Flex
                    direction={{ base: "column", md: "row" }}
                    justify="space-between"
                    mb={8}
                    align={{ base: "flex-start", md: "center" }}
                    gap={4}
                >
                    <Box>
                        <HStack spacing={3} mb={1}>
                            <FiUserX size={22} color="#f5365c" />
                            <Text fontSize={{ base: "xl", md: "2xl" }} fontWeight="800" color="#32325d">
                                KYC Unverified
                            </Text>
                        </HStack>
                        <Text fontSize="sm" color="#8898aa" fontWeight="500">
                            Users who have not submitted KYC documents
                        </Text>
                    </Box>

                    <InputGroup maxW={{ base: "100%", md: "350px" }} size="lg">
                        <Input
                            placeholder="Search unverified..."
                            value={search}
                            onChange={(e) => {
                                setSearch(e.target.value);
                                setPage(1);
                            }}
                            bg="white"
                            borderRadius="12px"
                            border="1px solid #f0f2f5"
                            fontSize="sm"
                            height="45px"
                            _focus={{
                                borderColor: "#f5365c",
                                boxShadow: "0 0 0 1px #f5365c",
                            }}
                        />
                        <InputRightElement h="45px" color="gray.400">
                            <FiSearch />
                        </InputRightElement>
                    </InputGroup>
                </Flex>

                {/* TABLE CONTAINER */}
                <Box
                    bg="white"
                    borderRadius="20px"
                    boxShadow="0 4px 6px -1px rgba(0, 0, 0, 0.05)"
                    overflow="hidden"
                    border="1px solid #f0f2f5"
                >
                    <TableContainer>
                        <Table variant="simple">
                            <Thead bg="#f6f9fc">
                                <Tr>
                                    <Th color="#8898aa" fontSize="xs" py={5} textTransform="uppercase">Bettor</Th>
                                    <Th color="#8898aa" fontSize="xs" py={5} textTransform="uppercase">Contact Info</Th>
                                    <Th color="#8898aa" fontSize="xs" py={5} textTransform="uppercase">Country</Th>
                                    <Th color="#8898aa" fontSize="xs" py={5} textTransform="uppercase">Joined</Th>
                                    <Th color="#8898aa" fontSize="xs" py={5} textTransform="uppercase">Balance</Th>
                                    <Th color="#8898aa" fontSize="xs" py={5} textTransform="uppercase">Action</Th>
                                </Tr>
                            </Thead>

                            <Tbody>
                                {data.map((b) => (
                                    <Tr key={b.id} _hover={{ bg: "#fcfdfe" }} transition="background 0.2s">
                                        <Td py={4}>
                                            <HStack spacing={3}>
                                                <Avatar size="sm" name={b.name} bg="#f5365c" color="white" />
                                                <Box>
                                                    <Text fontWeight="700" fontSize="sm" color="#32325d">{b.name}</Text>
                                                    <Text color="#5e72e4" fontSize="xs" fontWeight="600">{b.username}</Text>
                                                </Box>
                                            </HStack>
                                        </Td>

                                        <Td py={4}>
                                            <Text color="#32325d" fontSize="xs" fontWeight="700">{b.email}</Text>
                                            <Text color="#8898aa" fontSize="xs" fontWeight="500">{b.mobile}</Text>
                                        </Td>

                                        <Td py={4}>
                                            <Badge bg="rgba(245, 54, 92, 0.1)" color="#f5365c" px={3} py={1} borderRadius="10px" fontSize="xs">
                                                {b.country}
                                            </Badge>
                                        </Td>

                                        <Td py={4}>
                                            <Text color="#32325d" fontSize="xs" fontWeight="700">{b.joined}</Text>
                                            <Text color="#8898aa" fontSize="xs" fontWeight="500">{b.ago}</Text>
                                        </Td>

                                        <Td py={4}>
                                            <Text fontWeight="800" color="#32325d" fontSize="sm">{b.balance}</Text>
                                        </Td>

                                        <Td py={4}>
                                            <Button
                                                as={Link}
                                                to={`/Kyc-unverified/${b.id}`}
                                                size="sm"
                                                variant="outline"
                                                colorScheme="red"
                                                leftIcon={<FiEye />}
                                                borderRadius="10px"
                                                fontSize="xs"
                                                fontWeight="700"
                                                _hover={{ bg: "#f5365c", color: "white" }}
                                            >
                                                Details
                                            </Button>
                                        </Td>
                                    </Tr>
                                ))}
                            </Tbody>
                        </Table>
                    </TableContainer>
                </Box>

                {/* PAGINATION */}
                <Flex justify="center" mt={10} gap={2}>
                    <Button
                        size="sm"
                        variant="ghost"
                        onClick={() => setPage(page - 1)}
                        isDisabled={page === 1}
                        borderRadius="10px"
                        color="#8898aa"
                    >
                        Previous
                    </Button>

                    {[...Array(totalPages)].map((_, i) => (
                        <Button
                            key={i}
                            size="sm"
                            onClick={() => setPage(i + 1)}
                            bg={page === i + 1 ? "#f5365c" : "transparent"}
                            color={page === i + 1 ? "white" : "#8898aa"}
                            borderRadius="10px"
                            _hover={{ bg: page === i + 1 ? "#f5365c" : "#f6f9fc" }}
                            minW="40px"
                        >
                            {i + 1}
                        </Button>
                    ))}

                    <Button
                        size="sm"
                        variant="ghost"
                        onClick={() => setPage(page + 1)}
                        isDisabled={page === totalPages}
                        borderRadius="10px"
                        color="#8898aa"
                    >
                        Next
                    </Button>
                </Flex>
            </Box>
        </>
    );
}
